export default __webpack_public_path__ + "static/miagroupofcompanies-fab8fcf174ea5f1ce2c2496dd031a8a4.png";